/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';

const SwitchButton = ({ handleClick = () => null, label, className = '' }) => {
  const [toggle, setToggle] = useState(false);

  return (
    <div className={`switch-button ${className}`}>
      <label htmlFor="switch-button">{label}</label>
      <button
        id="switch-button"
        type="button"
        className={`wrg-toggle ${toggle ? 'wrg-toggle--checked' : ''}`}
        onClick={() => {
          handleClick(!toggle);
          setToggle(!toggle);
        }}
      >
        <div className="wrg-toggle-container">
          <div className="wrg-toggle-check" />
          <div className="wrg-toggle-uncheck" />
        </div>
        <div className="wrg-toggle-circle" />
        <input
          className="wrg-toggle-input"
          type="checkbox"
          aria-label="Toggle Button"
        />
      </button>
    </div>
  );
};

SwitchButton.propTypes = {
  handleClick: PropTypes.func
};

export default SwitchButton;
